import { getStudentData } from "./localStorage";

export const scoreCount = (ques, userAnswer) => {
  const isAnswerCorrect =
    ques.correct_text.toLowerCase() === userAnswer.toLowerCase();
  if (isAnswerCorrect) {
    return 1 * parseInt(ques.difficulty_level);
  } else {
    return 0;
  }
};

export const scoreCountMultiTap = (ques, selectedAns) => {
  // const isAnswerCorrect = ques.correct_choice === selectedAns;

  // console.log("ques in scoreCounter.js", ques);
  // console.log("selectedAns", selectedAns);

  // if (isAnswerCorrect) {
  //   return 1 * parseInt(ques.difficulty_level);
  // } else {
  //   return 0;
  // }

  const isSpatialRotationAverage =
    ques.custom_rule === "SPATIALROTATIONAVERAGE";
  console.log("ques in scoreCounter.js", ques);
  console.log("selectedAns", selectedAns);
  console.log("isSpatialRotationAverage", isSpatialRotationAverage);

  if (isSpatialRotationAverage) {
    const correctChoiceArr = ques.correct_choice.split(",");
    const selectedAnsArr = selectedAns.split(",");

    if (selectedAnsArr.length > correctChoiceArr.length) {
      console.log("selectedAns > correct_choice");
      return 0;
    } else {
      let numOfCorrectAns = selectedAnsArr.reduce(
        //(count, ans, i) => (correctChoiceArr[i] === ans ? count + 1 : count),
		(count, ans) => (correctChoiceArr.includes(ans) ? count + 1 : count),
        0
      );
      console.log("numOfCorrectAns", numOfCorrectAns);
      return numOfCorrectAns * ques.difficulty_level;
    }
  } else {
    const isAnswerCorrect = ques.correct_choice === selectedAns;

    if (isAnswerCorrect) {
      return 1 * parseInt(ques.difficulty_level);
    } else {
      return 0;
    }
  }
};

export const scoreCountReaction = (totalTime) => {
  const divideRoundHalfUp = (diff, divider) => {
    return diff / divider;
  };
  const grade_id = JSON.parse(localStorage.getItem("gradeId"));

  const gradeID = parseInt(grade_id);
  const L1 = gradeID <= 2;
  const L2 = gradeID > 2 && gradeID <= 5;
  const L3 = gradeID > 5 && gradeID <= 8;
  const L4 = gradeID > 8;

  console.log(typeof grade_id);
  if (L1) {
    if (totalTime > 100 && totalTime <= 250) {
      return 100;
    } else if (totalTime > 250 && totalTime <= 500) {
      let diff = totalTime - 250;
      diff = divideRoundHalfUp(diff, 10);
      return 100 - diff;
    } else if (totalTime > 500 && totalTime <= 750) {
      let diff = totalTime - 500;
      diff = divideRoundHalfUp(diff, 5);
      return 75 - diff;
    } else if (totalTime > 750 && totalTime <= 1250) {
      let diff = totalTime - 750;
      diff = divideRoundHalfUp(diff, 20);
      return 25 - diff;
    } else return 0;
  } else if (L2) {
    // level L2
    if (totalTime > 100 && totalTime <= 200) {
      return 100;
    } else if (totalTime > 200 && totalTime <= 450) {
      let diff = totalTime - 200;
      diff = divideRoundHalfUp(diff, 10);
      return 100 - diff;
    } else if (totalTime > 450 && totalTime <= 700) {
      let diff = totalTime - 450;
      diff = divideRoundHalfUp(diff, 5);
      return 75 - diff;
    } else if (totalTime > 700 && totalTime <= 1200) {
      let diff = totalTime - 700;
      diff = divideRoundHalfUp(diff, 20);
      return 25 - diff;
    } else return 0;
  } else if (L3 || L4) {
    if (totalTime > 100 && totalTime <= 150) {
      return 100;
    } else if (totalTime > 150 && totalTime <= 400) {
      let diff = totalTime - 150;
      diff = divideRoundHalfUp(diff, 10);
      return 100 - diff;
    } else if (totalTime > 400 && totalTime <= 650) {
      let diff = totalTime - 400;
      diff = divideRoundHalfUp(diff, 5);
      return 75 - diff;
    } else if (totalTime > 650 && totalTime <= 1150) {
      let diff = totalTime - 650;
      diff = divideRoundHalfUp(diff, 20);
      return 25 - diff;
    } else return 0;
  }
};

export const totalTimeOrScore = (data, questions, isReactionTest = false) => {
  let player_time = 0;
  let totalScore = 0;
  let player_score;

  data.forEach((data) => {
    // if que score is blank string then score summed with zero
    const queScore = !!data.que_score ? parseInt(data.que_score) : 0;
    totalScore = totalScore + queScore;
    player_time += parseInt(data.que_time);
  });

  if (questions[0].score_count === "single" && !isReactionTest) {
    player_score = totalScore;
  } else if (isReactionTest === "fnTest") {
    const actualScore = (totalScore / questions.length) * 100;
    player_score = parseInt(actualScore);
  } else {
    const actualScore = totalScore / questions.length;
    // scoring upto two decimal places
    player_score = parseInt(actualScore);
  }

  player_score = player_score ? parseFloat(player_score) : 0;

  console.log("actualScore", player_score);
  // if value is in minus then send player score as 0
  player_score = Math.sign(player_score) === -1 ? 0 : player_score;
  return {
    player_score,
    player_time,
  };
};

export const totalTimeOrScoreDigitSpan = (data) => {
  // Filter out objects with "que_score" not equal to 0
  const filteredData = data.filter(item => item.que_score !== 0);

  // Get the last item in the filtered array
  const lastItem = filteredData[filteredData.length - 1];

  // Extract relevant values
  const remember = lastItem.answer.split(',').length; // Length of answer field
  const tapCountIncorrect = parseInt(lastItem.answer_flag.split(' ')[0]); // Extract number from answer_flag

  // Initialize variables for score and digit
  let score = 0;
  let digit = 0;

  // Apply scoring logic based on "remember" and "tapCountIncorrect"
  if (remember === 3) {
    score = 30;
    digit = 3;
  } else if (remember === 4) {
    score = 40;
    digit = 4;
  } else if (remember === 5) {
    score = 50;
    digit = 5;
  } else if (remember === 6) {
    score = 60;
    digit = 6;
  } else if (remember === 7) {
    score = 70;
    digit = 7;
  } else if (remember === 8) {
    score = 80;
    digit = 8;
  } else if (remember === 9) {
    score = 90;
    digit = 9;
  } else if (remember === 10) {
    if (tapCountIncorrect === 0) {
      score = 100;
      digit = 10;
    } else {
      score = 90;
      digit = 9;
    }
  }

  // Modify que_score based on que_id
  filteredData.forEach(item => {
    if (item.que_id === 3) {
      item.que_score = 30;
    } else if (item.que_id === 4) {
      item.que_score = 40 - 30;
    } else if (item.que_id === 5) {
      item.que_score = 50 - 40; 
    } else if (item.que_id === 6) {
      item.que_score = 60 - 50; 
    } else if (item.que_id === 7) {
      item.que_score = 70 - 60; 
    } else if (item.que_id === 8) {
      item.que_score = 80 - 70; 
    } else if (item.que_id === 9) {
      item.que_score = 90 - 80; 
    } else if (item.que_id === 10) {
      if (tapCountIncorrect === 0) {
        score = 100;
      } else {
        item.que_score = 100 - 90;
      }
    }
  });

  // Return time, score, and modified data
  return {
    player_score: score,
    player_time: filteredData.reduce((total, item) => total + parseInt(item.que_time), 0),
    data: filteredData
  };
};
